declare var Card: any;
namespace AgerLMS.WebSite {

    export interface CartWidgetRequest {
        cargoPriceStr: string;
        cartCargoId?: number;
    }

    @Serenity.Decorators.registerClass()
    export class CartWidget extends Serenity.Widget<CartWidgetRequest> {

        cartTotal : number = 0;
        cargoPrice : number = 0;

        constructor(element: JQuery, opt: CartWidgetRequest) {
            super(element, opt);

            var self = this;
            this.cargoPrice = Q.coalesce(Q.parseDecimal(opt.cargoPriceStr.replace(",", ".")), 0);
            // Q.log("Cargo Price Str: " + opt.cargoPriceStr);
            // Q.log("Cargo Price: " + this.cargoPrice);

            this.initDistanceSalesAgreementLinkModal();
            this.initDiscount();
            this.prepareCargoSelect();

            LMS.ShoppingCartService.GetCart({}, r => {
                var productList = r.CartProducts;

                let makeQuantityEditor = (productList: WebSite.CartProduct) => {
                    let wrapper_div = $('<div class="product-show-cart-actions d-flex align-items-center flex-wrap "></div>');
                    let cart_quantity_div = $('<div class="cart-quantity d-flex align-items-center mt-20 mr-15"></div>');
                    let minus_button = $('<button type="button" class="minus d-flex align-items-center justify-content-center"><i class="fa fa-minus fa-lg"></i></button>');
                    let input = $('<input type="number" name="quantity" value="' + productList.Quantity + '" data-key="' + productList.CartKey + '">');
                    let plus_button = $('<button type="button" class="plus d-flex align-items-center justify-content-center"><i class="fa fa-plus fa-lg"></i></button>');

                    minus_button.click(e => {
                        let $input = minus_button.parent().find('input');
                        let count = parseInt($input.val()) - 1;
                        count = count < 1 ? 1 : count;

                        $input.val(count);
                        $input.change();
                        return false;
                    });

                    plus_button.click(e => {
                        let $input = plus_button.parent().find('input');
                        $input.val(parseInt($input.val()) + 1);
                        $input.change();
                        return false;
                    });

                    input.change(e => {
                        let $input = input;
                        let cartKey = $input.data("key");

                        LMS.ShoppingCartService.Update({ Entity: { CartKey : cartKey, Quantity: Q.toId($input.val()) } }, response => {
                            window.location.reload();
                        }, {
                            onError: response => {
                                SweetAlert.swal_alert("Hata", response.Error.Message);
                            }
                        });
                    });

                    cart_quantity_div.append(minus_button);
                    cart_quantity_div.append(input);
                    cart_quantity_div.append(plus_button);

                    wrapper_div.append(cart_quantity_div);

                    return wrapper_div;
                }


                let makeItem = (cart: WebSite.CartProduct) => {
                    let q = (cart.Quantity || 1);
                    let li = $('<li class="list-group-item d-flex justify-content-between lh-sm"></li>');
                    let div = $('<div></div>');
                    let h6 = $('<h6 class="my-0"></h6>');
                    let small = $('<small class="text-muted"></small>');
                    let span = $('<span class="text-muted"></span>');
    
                    h6.text(cart.ItemName);
                    let smallText = cart.ItemName;
                    if (cart.UsagePeriod != null) {
                        smallText = '(' + cart.UsagePeriod + ' gün ' + cart.WatchCount + ' izleme)';
                    }
                    small.text(smallText);
                    span.html(this.trPriceHtml((cart.Price * q)) );
    
                    div.append(h6);
                    div.append(small);
                    if (cart.Type == "Books") div.append(makeQuantityEditor(cart));
                    li.append(div);
                    li.append(span);

                    let removeButton = $('<button type="button" class="btn btn-danger btn-xxs"><i class="fa fa-trash"></i></button>');
                    removeButton.click(e => {
                        LMS.ShoppingCartService.Delete({
                            EntityId: cart.CartKey
                        }, response => {
                            window.location.reload();                            
                        });
                    });
                    li.append(removeButton);
    
                    return li;
                }

                var cartList = $('ul.cart-list');
                for (var i = 0; i < productList.length; i++) {
                    let q = (productList[i].Quantity || 1);
                    this.cartTotal += (productList[i].Price * q);
                    // if (cart[i].TypeKey.indexOf('Books') == 0)
                    //     this.cargoTotal += (self.cargoPrice * q);
                    cartList.append(makeItem(productList[i]));
                }

                if (productList.length == 0) {
                    cartList.append($('<li class="list-group-item d-flex justify-content-between lh-sm text-danger"></li>').text('Sepetinizde ürün bulunmamaktadır.'));
                } 
                else 
                {
                    if (self.cargoPrice && self.cargoPrice > 0) {
                        //Kargo ücreti hesaplanıp ekleniyor
                        let shippingLi = $('<li class="list-group-item d-flex justify-content-between"></li>');
                        let shippingSpan = $('<span/>').text('Kargo Ücreti');
                        let shippingStrong = $('<strong/>').html(this.trPriceHtml(self.cargoPrice));
                        shippingLi.append(shippingSpan);
                        shippingLi.append(shippingStrong);
                        cartList.append(shippingLi);
                        this.cartTotal += self.cargoPrice;
                    }

                    if (r.DiscountId && r.DiscountId > 0) {
                        let discountLi = $('<li id="DiscountId" class="list-group-item d-flex justify-content-between"></li>');
                        discountLi.data('DiscountId', r.DiscountId);
                        let discountSpan = $('<span/>').text('Kupon İndirim');
                        let discountStrong = $('<strong/>').html(this.trPriceHtml(r.DiscountAmount));
                        discountLi.append(discountSpan);
                        discountLi.append(discountStrong);
                        cartList.append(discountLi);
                        this.cartTotal -= r.DiscountAmount;

                        let li1 = $('<li class="list-group-item d-flex justify-content-between mt-5"></li>');
                        li1.data('DiscountId', r.DiscountId);
                        let li1Span = $('<span/>').text('KUPON : ');
                        let li1Strong = $('<strong/>').html(r.Discount.Coupon);
                        li1.append(li1Span);
                        li1Span.append(li1Strong);
                        let removeButton = $('<button title="Kuponu Sil" type="button" class="btn btn-danger btn-xxs"><i class="fa fa-close"></i></button>');
                        removeButton.click(e => {
                            LMS.ShoppingCartService.SetCartDiscount({
                            }, response => {
                                window.location.reload();                            
                            });
                        });
                        li1.append(removeButton);

                        $('#DiscountCodeCheck').append(li1);
                    }

                    let totalLi = $('<li class="list-group-item d-flex justify-content-between"></li>');
                    let totalSpan = $('<span/>').text('GENEL TOPLAM');
                    let totalStrong = $('<strong/>').html(this.trPriceHtml(this.cartTotal));
                    totalLi.append(totalSpan);
                    totalLi.append(totalStrong);
                    cartList.append(totalLi);

                    $('section .total-price, .cart-items-count').html(this.trPriceHtml(this.cartTotal));
                    $('.cart-items-count').text(productList.length);
                }
            });
        }

        trPriceHtml(price?: any): string {
            price = price || 0;
    
            if (price != null)
                return "<span class='tr-price'>₺</span> " + parseFloat(price).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1.').replace(/\.(\d+)$/,',$1') 
        }

        initDiscount() {
            $('#CheckDiscountCode').on('click', e => {
                this.checkDiscountCode();
            });
        }

        prepareCargoSelect() {

            var self = this;
            if (self.cargoPrice > 0) {
                var cargos = Q.getLookup<LMS.CargoRow>("LMS.Cargos");
                var data = cargos.items.map(x => { return { id: x.Id, text: x.CargoName } });
                let cargoElement = ($("#selectCargo") as any);
                cargoElement.select2({
                    placeholder: "Kargo Seçiniz",
                    allowClear: true,
                    data: data,
                });
                cargoElement.val(self.options.cartCargoId);
                cargoElement.trigger("change");

                cargoElement.on("change", function (e) {
                    var cargoId = Q.toId(cargoElement.val());
                    LMS.ShoppingCartService.SetCartSelectedCargo({
                        EntityId: cargoId
                    }, response => {
                        window.location.reload();                            
                    });
                });
            } else {
                $('#selectCargoCardDiv').hide();
            }
        }

        private checkDiscountCode() {
            SweetAlert.swal_loading('İndirim kodu kontrol ediliyor...');
            var couponCode = $('#DiscountCode');
            // window.setTimeout(() => {
                LMS.DiscountsService.CheckCouponCode({
                    CouponCode: couponCode.val()
                }, response => {
                    SweetAlert.swal_close();
                    // SweetAlert.swal_info("Bilgi", JSON.stringify(response));
                    SweetAlert.swal_confirm("Onay", "İndirim kodu kontrol edildi, girmiş olduğunuz kupon kullanıma açık. Sizin için " + this.trPriceHtml(response.DiscountAmount) + " indirim yapılacaktır. Onaylıyor musunuz?", () => {
                        LMS.ShoppingCartService.SetCartDiscount({
                            EntityId: response.DiscountId
                        }, response => {
                            window.location.reload();                            
                        });
                    });
                }, {
                    onError: (response) => {
                        SweetAlert.swal_close();
                        SweetAlert.swal_alert("HATA", response.Error.Message);
                        couponCode.val('');
                        couponCode.focus();
                    }
                });
                
            // }, 3000);
        }

        initDistanceSalesAgreementLinkModal () {

            let fillDistanceSalesAgreement = (callback : (response)=> void) => {
                let adrressId = $('#shipping_addressId').val();
                $('#DistanceSalesAgreementModal .modal-body').html("");
                CMS.CmsPageService.GetMeDistanceSalesAgreement({ UserAdressId: Q.toId(adrressId) }, response => {
                    callback(response);
                });
            }

            $('#DistanceSalesAgreementLink').on('click', e => {
                e.preventDefault();
                fillDistanceSalesAgreement((response)=> {
                    $('#DistanceSalesAgreementModal .modal-body').html("");
                    $('#DistanceSalesAgreementModal .modal-body').html(response.Entity);
                    let m = ($('#DistanceSalesAgreementModal') as any);
                    m.modal({ keyboard: false, backdrop: 'static' });
                    m.modal('show');
                });
            });

            $('#AcceptDistanceSalesAgreementPdf').on('click', e => {
                e.preventDefault();
                const pdf = new jsPDF('p', 'pt', 'a4');
                let specialElementHandlers = {
                    '#DistanceSalesAgreementModal .modal-body': function (element, renderer) {
                        return true;
                    }
                  };
                pdf.fromHTML($('#DistanceSalesAgreementModal .modal-body').html(),20,20,{
                    width:500,
                    elementHandlers: specialElementHandlers
                });
                setTimeout(function () {
                    pdf.save("AcceptDistanceSalesAgreement.pdf");
                }, 0);  
            });
        }
    }
}